import {Helmet} from '@dr.pogodin/react-helmet';
import {match} from 'ts-pattern';

import {isNotString} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds, vehiclesRoutes} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid, Main} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['vehicle'] as const;

export function AuctionList() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    getColumnData,
  }) => {
    const vehicleId = getColumnData<{id: string}>('vehicle')?.value?.id;

    if (isNotString(vehicleId)) {
      return;
    }

    const path = composePath(vehiclesRoutes.auction, {
      params: {id: vehicleId},
      isSearchParamsPreserved: false,
    });

    match(actionKey)
      .with('detail', () => navigate(path))
      .with('detail_newTab', () => window.open(path))
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <>
      <Helmet title={i18n.t('entity.auction.labels.auction')} />
      <Main isFullHeight heading={i18n.t('entity.auction.labels.auction')}>
        <DmsDataGrid
          gridCode="auction"
          actionCallback={actionCallback}
          predefinedColumns={PREDEFINED_COLUMNS}
          data-testid={testIds.auction.overview('datagrid')}
        />
      </Main>
    </>
  );
}
